import { render, staticRenderFns } from "./PerlengkapanLainCard.vue?vue&type=template&id=5c629750&"
import script from "./PerlengkapanLainCard.vue?vue&type=script&lang=js&"
export * from "./PerlengkapanLainCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports